import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';
import { SocialProofBar } from '../../components/SocialProofBar';
import { TrustBadges } from '../../components/TrustBadges';
export function KidsTaekwondoHeroInfo() {
  return <div className="flex flex-col items-start" data-id="element-2206">
      <div className="inline-block bg-storm-red text-white px-4 py-1.5 rounded-full text-sm font-bold uppercase tracking-wide mb-6" data-id="element-2207">
        Kids Taekwondo
      </div>
      <div className="mb-8" data-id="element-2208">
        <SocialProofBar data-id="element-2209" />
      </div>
      <h1 className="text-5xl md:text-6xl text-white mb-6 leading-[1.1]" data-id="element-2210">
        Kids Taekwondo & Martial Arts Classes in Farmington Hills
      </h1>
      <p className="text-xl text-off-white mb-8 max-w-xl leading-relaxed" data-id="element-2211">
        Storm Taekwondo helps kids build confidence, focus, discipline, fitness,
        respect and real Taekwondo skills in a positive coaching environment.
        Mini Troopers ages 3–5, Kids Taekwondo ages 6+. Beginner-friendly — no
        experience needed.
      </p>

      <ul className="flex flex-col gap-3 mb-10" data-id="element-2212">
        {['Respect for parents, teachers, and peers', 'Goal setting through the belt progression system', 'Physical fitness, balance, and coordination', 'Self-defense fundamentals and stranger awareness'].map((item, idx) => <li key={idx} className="flex items-center gap-3 text-white text-lg" data-id="element-2213">
            <CheckCircle2 className="w-6 h-6 text-storm-red shrink-0" data-id="element-2214" />
            <span data-id="element-2215">{item}</span>
          </li>)}
      </ul>

      <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto mb-10" data-id="element-2216">
        <Link to="/SignMeUp" className="btn-primary" data-id="element-2217">
          Start With a Trial Class
        </Link>
        <a href="tel:517-220-0621" className="btn-secondary" data-id="element-2218">
          Call 517-220-0621
        </a>
      </div>
      <TrustBadges data-id="element-2219" />
    </div>;
}